document.addEventListener('DOMContentLoaded', function () {
  const tabComponents = document.querySelectorAll('[data-tab-component]');

  tabComponents.forEach(function (component) {
    const tabButtons = component.querySelectorAll('.nk-custom-tab-button');
    const tabPanels = component.querySelectorAll('.nk-custom-tab-panel');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const targetId = button.getAttribute('data-tab-target');

        tabButtons.forEach(function (btn) {
          btn.classList.remove('nk-is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        tabPanels.forEach(function (panel) {
          panel.classList.remove('nk-is-active');
        });

        button.classList.add('nk-is-active');
        button.setAttribute('aria-selected', 'true');

        const targetPanel = component.querySelector('#' + targetId);
        if (targetPanel) {
          targetPanel.classList.add('nk-is-active');
        }
      });
    });
  });
});